







































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import DocumentMixin from '@/mixins/DocumentMixin';

@Component
export default class LinesTable extends Mixins(DocumentMixin) {
  // Props
  @Prop(Array) public lines!: object[];
  @Prop(Boolean) public isReadOnly!: boolean;
  @Prop(Number) public version!: number;
  @Prop(Boolean) public isArchitect!: boolean;

  public labelCols = '0';
  public inputCols = '12';
}
